import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiClose } from "@mdi/js";

// Generic confirmation modal. `actions` is a flat array; pass `slot: "left"`
// to push an action into the left footer slot. Pass `requireConfirmation`
// to gate `requiresConfirm` actions behind a checkbox.
const EditConfirmModal = ({
  show,
  onHide,
  title,
  children,
  actions = [],
  requireConfirmation,
  dialogClassName,
}) => {
  const [confirmed, setConfirmed] = useState(false);

  useEffect(() => {
    if (!show) setConfirmed(false);
  }, [show]);

  const leftActions = actions.filter((a) => a.slot === "left");
  const rightActions = actions.filter((a) => a.slot !== "left");

  const renderButton = (action, idx) => (
    <Button
      key={idx}
      variant={action.variant || "outline-secondary"}
      onClick={action.onClick}
      disabled={
        action.disabled ||
        (action.requiresConfirm && requireConfirmation && !confirmed)
      }
      className={action.className}
    >
      {action.label}
    </Button>
  );

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      className="webedit-bottom-modal"
      dialogClassName={dialogClassName || "edit-confirm-modal"}
    >
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
        <Button
          variant="link"
          onClick={onHide}
          className="edit-confirm-modal-close"
          aria-label="Close"
        >
          <Icon path={mdiClose} size={1} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <div className="edit-confirm-modal-body">{children}</div>
        {requireConfirmation && (
          <Form.Check
            type="checkbox"
            id="edit-confirm-modal-verify"
            label={requireConfirmation}
            checked={confirmed}
            onChange={(e) => setConfirmed(e.target.checked)}
            className="edit-confirm-modal-checkbox"
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        {leftActions.length > 0 && (
          <div className="edit-confirm-modal-footer-left">
            {leftActions.map(renderButton)}
          </div>
        )}
        <div className="edit-confirm-modal-footer-right">
          {rightActions.map(renderButton)}
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default EditConfirmModal;
